import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  loginMessage = new BehaviorSubject("");
  managedMessage = new BehaviorSubject("");
  license = new BehaviorSubject("");
  licenseStatus = new BehaviorSubject("");
  currentMessage = this.loginMessage.asObservable();
  licenseMessage = this.license.asObservable();
  notifications: Subject<Object> = new Subject<Object>();
  licenseManaged = this.managedMessage.asObservable();

  constructor() { }

  updateFlashMessage(message: string) {
      this.loginMessage.next(message);
  }

  updateLicenseMessage(message: string) {
      this.license.next(message);
  }

  updateManagedMessage(message: string) {
      this.managedMessage.next(message);
  }

  updateLicenseStatus(message: string) {
      this.licenseStatus.next(message);
  }
}
